import React, { useState } from 'react';
import Combo1 from '../asstes/umed/Combo_1.webp';
import CraftedSacred from '../asstes/umed/Crafted_from_Sacred_Ingredients.webp';
import PureSacred from '../asstes/umed/Pure_Sacred_Ingredients.webp';
import UMCombo from '../asstes/umed/UM-DC-ML-4-COMBO01.webp';
import UmedLogo from '../asstes/umed/images.jpg';
import { useLanguage } from '../context/LanguageContext';

const WomenGroup = () => {
  const { language } = useLanguage();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');

  // Product data
  const products = [
    {
      id: 1,
      name: { marathi: 'हातकामाचे बैग', english: 'Handmade Bags' },
      englishName: 'Handmade Bags',
      price: '₹ 450',
      originalPrice: '₹ 600',
      discount: '25%',
      image: Combo1,
      category: 'handicraft',
      description: { marathi: 'हाताने विणलेले कापडाचे बैग, टिकाऊ आणि सुंदर डिझाईन.', english: 'Handwoven cloth bags, durable and beautiful design.' },
      detailedDescription: { marathi: 'हा बैग महिला बचत गटाच्या सदस्यांनी हाताने विणलेला आहे. 100% कॉटन कापडापासून बनवलेला, पारंपारिक डिझाईन असलेला हा बैग टिकाऊ आणि वापरायला सोपा आहे. शॉपिंग, पिकनिक किंवा दैनंदिन वापरासाठी उत्तम.', english: 'This bag is handwoven by women self-help group members. Made from 100% cotton fabric with a traditional design, this bag is durable and easy to use. Great for shopping, picnics, or daily use.' },
      material: { marathi: '100% कापूस', english: '100% Cotton' },
      size: { marathi: '30 x 40 सेमी', english: '30 x 40 cm' },
      weight: { marathi: '300 ग्रॅम', english: '300 Grams' },
      careInstructions: { marathi: 'हाताने धुवा, थंड पाणी वापरा', english: 'Hand wash, use cold water' },
      inStock: true,
      stockCount: 25,
      rating: 4.5,
      reviews: 18,
    },
    {
      id: 2,
      name: { marathi: 'पारंपारिक साडी', english: 'Traditional Saree' },
      englishName: 'Traditional Saree',
      price: '₹ 1200',
      originalPrice: '₹ 1500',
      discount: '20%',
      image: CraftedSacred,
      category: 'clothing',
      description: { marathi: 'हातकामाची पारंपारिक महाराष्ट्रीयन साडी.', english: 'Handcrafted traditional Maharashtrian Saree.' },
      detailedDescription: { marathi: 'ही साडी महाराष्ट्राच्या पारंपारिक डिझाईनमध्ये हाताने विणली गेली आहे. पाऊस नाच मोतीचे काम केलेले, ही साडी विवाह, सण इत्यादी प्रसंगी परिधान करण्यासाठी उत्तम.', english: 'This saree is handwoven in traditional Maharashtrian design. Featuring beautiful pearl work, it is perfect for weddings, festivals, and other occasions.' },
      material: { marathi: 'शुद्ध रेशीम', english: 'Pure Silk' },
      size: { marathi: '5.5 मीटर लांबी', english: '5.5 Meters long' },
      weight: { marathi: '800 ग्रॅम', english: '800 Grams' },
      careInstructions: { marathi: 'ड्राय क्लीन करा', english: 'Dry Clean Only' },
      inStock: true,
      stockCount: 12,
      rating: 4.8,
      reviews: 32,
    },
    {
      id: 3,
      name: { marathi: 'बांबूची टोपली', english: 'Bamboo Basket' },
      englishName: 'Bamboo Basket',
      price: '₹ 350',
      originalPrice: '₹ 400',
      discount: '12%',
      image: PureSacred,
      category: 'handicraft',
      description: { marathi: 'हाताने विणलेली बांबूची टोपली, घरगुती वापरासाठी.', english: 'Handwoven bamboo basket for household use.' },
      detailedDescription: { marathi: 'ही टोपली स्थानिक बांबूपासून हाताने विणली गेली आहे. फळे, भाजीपाला किंवा घरगुती सामान ठेवण्यासाठी उपयुक्त. पर्यावरणास अनुकूल आणि टिकाऊ.', english: 'This basket is handwoven from local bamboo. Useful for keeping fruits, vegetables, or household items. Eco-friendly and durable.' },
      material: { marathi: 'नैसर्गिक बांबू', english: 'Natural Bamboo' },
      size: { marathi: 'व्यास: 30 सेमी, उंची: 15 सेमी', english: 'Diameter: 30 cm, Height: 15 cm' },
      weight: { marathi: '250 ग्रॅम', english: '250 Grams' },
      careInstructions: { marathi: 'कोरडे ठेवा, थेट सूर्यप्रकाश टाळा', english: 'Keep dry, avoid direct sunlight' },
      inStock: true,
      stockCount: 40,
      rating: 4.3,
      reviews: 15,
    },
    {
      id: 4,
      name: { marathi: 'आयुर्वेदिक साबण', english: 'Ayurvedic Soap' },
      englishName: 'Ayurvedic Soap',
      price: '₹ 75',
      originalPrice: '₹ 90',
      discount: '17%',
      image: UMCombo,
      category: 'personal-care',
      description: { marathi: 'नैसर्गिक आयुर्वेदिक औषधी वनस्पतींपासून बनवलेला साबण.', english: 'Soap made from natural Ayurvedic herbs.' },
      detailedDescription: { marathi: 'हा साबण आयुर्वेदिक तत्त्वांनुसार नीम, तुळस, चंदन इत्यादी औषधी वनस्पतींपासून बनवला आहे. त्वचेसाठी सौम्य आणि फायदेशीर. केमिकल मुक्त.', english: 'This soap is made from herbs like Neem, Tulsi, and Sandalwood based on Ayurvedic principles. Gentle and beneficial for the skin. Chemical-free.' },
      material: { marathi: 'नीम, तुळस, चंदन तेल', english: 'Neem, Tulsi, Sandalwood Oil' },
      size: { marathi: '100 ग्रॅम', english: '100 Grams' },
      weight: { marathi: '100 ग्रॅम', english: '100 Grams' },
      careInstructions: { marathi: 'कोरड्या ठिकाणी ठेवा', english: 'Store in a dry place' },
      inStock: true,
      stockCount: 100,
      rating: 4.7,
      reviews: 45,
    },
    {
      id: 5,
      name: { marathi: 'हातकामाचे गहने', english: 'Handmade Jewelry' },
      englishName: 'Handmade Jewelry',
      price: '₹ 650',
      originalPrice: '₹ 850',
      discount: '24%',
      image: Combo1,
      category: 'jewelry',
      description: { marathi: 'हाताने बनवलेली चांदीची पारंपारिक गहने.', english: 'Handcrafted traditional silver jewelry.' },
      detailedDescription: { marathi: 'ही गहने चांदी आणि रंगीत दगडांपासून हाताने बनवली गेली आहेत. पारंपारिक महाराष्ट्रीयन डिझाईन, विवाह आणि सणांसाठी उत्तम.', english: 'This jewelry is handcrafted from silver and colored stones. Traditional Maharashtrian design, great for weddings and festivals.' },
      material: { marathi: '92.5% चांदी', english: '92.5% Silver' },
      size: { marathi: 'सर्व आकार उपलब्ध', english: 'All sizes available' },
      weight: { marathi: '25-50 ग्रॅम', english: '25-50 Grams' },
      careInstructions: { marathi: 'कोमेक्स सोल्यूशनमध्ये स्वच्छ करा', english: 'Clean in jewelry solution' },
      inStock: true,
      stockCount: 30,
      rating: 4.9,
      reviews: 28,
    },
    {
      id: 6,
      name: { marathi: 'ऑर्गेनिक मसाले', english: 'Organic Spices' },
      englishName: 'Organic Spices',
      price: '₹ 200',
      originalPrice: '₹ 250',
      discount: '20%',
      image: CraftedSacred,
      category: 'food',
      description: { marathi: 'शेतकरी महिलांनी उपजवलेले शुद्ध मसाले.', english: 'Pure spices cultivated by women farmers.' },
      detailedDescription: { marathi: 'ही मसाले शेतकरी महिला बचत गटाच्या सदस्यांनी रासायनिक मुक्त पद्धतीने उपजवली आहेत. 100% शुद्ध, कोणत्याही मिसळीशिवाय. स्वाद आणि आरोग्यासाठी उत्तम.', english: 'These spices are grown chemically-free by women farmers of the self-help group. 100% pure, without any adulteration. Great for taste and health.' },
      material: { marathi: 'शुद्ध मसाले', english: 'Pure Spices' },
      size: { marathi: '200 ग्रॅम पॅक', english: '200 Gram Pack' },
      weight: { marathi: '200 ग्रॅम', english: '200 Grams' },
      careInstructions: { marathi: 'कोरड्या ठिकाणी, हवाबंद डब्यात ठेवा', english: 'Store in an airtight container in a dry place' },
      inStock: true,
      stockCount: 60,
      rating: 4.6,
      reviews: 52,
    },
    {
      id: 7,
      name: { marathi: 'ब्लॉक प्रिंट कापड', english: 'Block Print Fabric' },
      englishName: 'Block Print Fabric',
      price: '₹ 800',
      originalPrice: '₹ 1000',
      discount: '20%',
      image: PureSacred,
      category: 'textile',
      description: { marathi: 'हाताने ब्लॉक प्रिंट केलेले कापड, स्टोल किंवा स्कार्फसाठी.', english: 'Hand block printed fabric for stole or scarf.' },
      detailedDescription: { marathi: 'हा कापड हाताने ब्लॉक प्रिंट पद्धतीने छापला गेला आहे. नैसर्गिक रंगांचा वापर केला आहे. स्टोल, स्कार्फ किंवा घरगुती सजावटीसाठी उपयुक्त.', english: 'This fabric is printed using hand block printing techniques. Natural dyes are used. Useful for stoles, scarves, or home decoration.' },
      material: { marathi: '100% कापूस', english: '100% Cotton' },
      size: { marathi: '2 मीटर x 1 मीटर', english: '2 Meters x 1 Meter' },
      weight: { marathi: '400 ग्रॅम', english: '400 Grams' },
      careInstructions: { marathi: 'हाताने धुवा, थंड पाणी वापरा', english: 'Hand wash, use cold water' },
      inStock: true,
      stockCount: 35,
      rating: 4.4,
      reviews: 23,
    },
    {
      id: 8,
      name: { marathi: 'दिव्यागुंडी', english: 'Diya & Gudi' },
      englishName: 'Diya & Gudi',
      price: '₹ 150',
      originalPrice: '₹ 180',
      discount: '17%',
      image: UMCombo,
      category: 'festival',
      description: { marathi: 'मातीचे दिवे आणि गुंड्या, दिवाळीसाठी विशेष.', english: 'Earthen diyas and gudis, special for Diwali.' },
      detailedDescription: { marathi: 'ही दिव्यागुंडी स्थानिक मातीपासून हाताने बनवली गेली आहे. दिवाळी, गुढी पाडवा इत्यादी सणांसाठी उत्तम. पारंपारिक डिझाईन आणि नैसर्गिक रंग.', english: 'These diyas and gudis are handmade from local clay. Perfect for festivals like Diwali and Gudi Padwa. Traditional design and natural colors.' },
      material: { marathi: 'माती', english: 'Clay' },
      size: { marathi: 'विविध आकार', english: 'Various sizes' },
      weight: { marathi: '50-100 ग्रॅम', english: '50-100 Grams' },
      careInstructions: { marathi: 'साचेखोल ठिकाणी ठेवा', english: 'Store safely in a safe place' },
      inStock: true,
      stockCount: 200,
      rating: 4.8,
      reviews: 67,
    },
  ];

  const categories = [
    { id: 'all', marathi: 'सर्व प्रकार', english: 'All Categories' },
    { id: 'handicraft', marathi: 'हस्तकला', english: 'Handicraft' },
    { id: 'clothing', marathi: 'कपडे', english: 'Clothing' },
    { id: 'personal-care', marathi: 'वैयक्तिक काळजी', english: 'Personal Care' },
    { id: 'jewelry', marathi: 'गहने', english: 'Jewelry' },
    { id: 'food', marathi: 'अन्नपदार्थ', english: 'Food' },
    { id: 'textile', marathi: 'कापड', english: 'Textile' },
    { id: 'festival', marathi: 'सणासमारंभ', english: 'Festivals' },
  ];

  const handleProductClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  const filteredProducts = products.filter(product => {
    const searchString = searchQuery.toLowerCase();
    const matchesSearch = product.name.marathi.toLowerCase().includes(searchString) ||
                         product.name.english.toLowerCase().includes(searchString) ||
                         product.description.marathi.toLowerCase().includes(searchString) ||
                         product.description.english.toLowerCase().includes(searchString);
    const matchesCategory = categoryFilter === 'all' || product.category === categoryFilter;
    return matchesSearch && matchesCategory;
  });

  const getCategoryName = (catId) => {
    const cat = categories.find(c => c.id === catId);
    return cat ? (language === 'marathi' ? cat.marathi : cat.english) : '';
  };

  const productCardStyle = {
    background: 'linear-gradient(135deg, #ffffff 0%, #fef3f3 100%)',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
  };

  const sectionTitleStyle = {
    color: '#db2777',
    fontSize: '28px',
    fontWeight: '800',
    marginBottom: '10px',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-rose-50 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="flex justify-center items-center mb-4">
            <div className="mr-4">
              <img 
                src={UmedLogo} 
                alt="Umed Market Logo" 
                className="w-32 h-32 object-contain bg-transparent"
                style={{ backgroundColor: 'transparent' }}
              />
            </div>
            <div>
              <h1 className="text-4xl font-bold text-gray-800">
                {language === 'marathi' ? 'महिला बचत गट उत्पादने' : 'Women Self-Help Group Products'}
              </h1>
              <p className="text-rose-600 text-lg font-medium">
                {language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत - स्वयंरोजगार उद्योग' : 'Gram Panchayat Inam Dhamani - Self-Employment Industry'}
              </p>
            </div>
          </div>
          <div className="mt-6 w-32 h-1 bg-gradient-to-r from-pink-400 to-rose-400 mx-auto rounded-full"></div>
        </div>

        {/* Stats Banner */}
        <div className="mb-10 grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-gradient-to-r from-pink-100 to-rose-100 p-4 rounded-lg border border-pink-200 text-center">
            <div className="text-2xl font-bold text-rose-700">50+</div>
            <div className="text-sm text-rose-600">{language === 'marathi' ? 'उत्पादने' : 'Products'}</div>
          </div>
          <div className="bg-gradient-to-r from-purple-100 to-pink-100 p-4 rounded-lg border border-purple-200 text-center">
            <div className="text-2xl font-bold text-purple-700">15</div>
            <div className="text-sm text-purple-600">{language === 'marathi' ? 'महिला गट' : 'Women Groups'}</div>
          </div>
          <div className="bg-gradient-to-r from-blue-100 to-cyan-100 p-4 rounded-lg border border-blue-200 text-center">
            <div className="text-2xl font-bold text-blue-700">200+</div>
            <div className="text-sm text-blue-600">{language === 'marathi' ? 'विक्री' : 'Sales'}</div>
          </div>
          <div className="bg-gradient-to-r from-green-100 to-emerald-100 p-4 rounded-lg border border-green-200 text-center">
            <div className="text-2xl font-bold text-green-700">4.7 ★</div>
            <div className="text-sm text-green-600">{language === 'marathi' ? 'ग्राहक रेटिंग' : 'Customer Rating'}</div>
          </div>
        </div>

        {/* Search and Filter */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row gap-4 justify-between items-center">
            <div className="flex-1 w-full md:w-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder={language === 'marathi' ? 'उत्पादन शोधा...' : 'Search products...'}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full p-3 pl-12 rounded-lg border border-pink-300 focus:ring-2 focus:ring-pink-500 focus:border-pink-500"
                />
                <span className="absolute left-4 top-3.5 text-gray-400">🔍</span>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {categories.map(category => (
                <button
                  key={category.id}
                  onClick={() => setCategoryFilter(category.id)}
                  className={`px-4 py-2 rounded-full font-medium transition-all ${
                    categoryFilter === category.id
                      ? 'bg-gradient-to-r from-pink-500 to-rose-500 text-white'
                      : 'bg-white text-gray-700 border border-pink-200 hover:bg-pink-50'
                  }`}
                >
                  {language === 'marathi' ? category.marathi : category.english}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div>
          <h2 style={sectionTitleStyle} className="mb-8">
            {getCategoryName(categoryFilter)}
          </h2>
          
          {filteredProducts.length === 0 ? (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">😔</div>
              <h3 className="text-xl font-bold text-gray-700 mb-2">
                {language === 'marathi' ? 'उत्पादन सापडले नाही' : 'Product not found'}
              </h3>
              <p className="text-gray-600">
                {language === 'marathi' ? 'तुमच्या शोधाशी जुळणारे उत्पादन सध्या उपलब्ध नाही' : 'No product matching your search is currently available'}
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {filteredProducts.map(product => (
                <div
                  key={product.id}
                  style={productCardStyle}
                  className="group hover:shadow-xl hover:-translate-y-2"
                  onClick={() => handleProductClick(product)}
                >
                  {/* Product Image */}
                  <div className="relative overflow-hidden h-48">
                    <img
                      src={product.image}
                      alt={product.name[language] || product.name.marathi}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    {product.discount && (
                      <div className="absolute top-3 left-3 bg-gradient-to-r from-red-500 to-pink-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                        {product.discount} OFF
                      </div>
                    )}
                    {!product.inStock && (
                      <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                        <span className="bg-white px-4 py-2 rounded-full font-bold text-red-600">
                          {language === 'marathi' ? 'संपले' : 'Out of Stock'}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Product Info */}
                  <div className="p-4">
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h3 className="font-bold text-gray-800 text-lg">{product.name[language] || product.name.marathi}</h3>
                        <p className="text-gray-600 text-sm">{getCategoryName(product.category)}</p>
                      </div>
                      <div className="flex items-center bg-pink-50 px-2 py-1 rounded">
                        <span className="text-yellow-500 mr-1">★</span>
                        <span className="font-bold">{product.rating}</span>
                      </div>
                    </div>

                    <p className="text-gray-600 text-sm mb-3 line-clamp-2">{product.description[language] || product.description.marathi}</p>

                    <div className="flex justify-between items-center">
                      <div>
                        <span className="text-xl font-bold text-rose-600">{product.price}</span>
                        {product.originalPrice && (
                          <span className="text-gray-400 line-through text-sm ml-2">
                            {product.originalPrice}
                          </span>
                        )}
                      </div>
                      <button className="bg-gradient-to-r from-pink-500 to-rose-500 text-white px-4 py-2 rounded-lg font-medium hover:shadow-lg transition-shadow">
                        {language === 'marathi' ? 'कार्टमध्ये ठेवा' : 'Add to Cart'}
                      </button>
                    </div>

                    <div className="mt-3 flex justify-between text-xs text-gray-500">
                      <span>📦 {language === 'marathi' ? 'स्टॉक:' : 'Stock:'} {product.stockCount}</span>
                      <span>👁️ {product.reviews} {language === 'marathi' ? 'रिव्ह्यू' : 'Reviews'}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* About Section */}
        <div className="mt-16 p-8 bg-gradient-to-r from-pink-50 to-purple-50 rounded-2xl border border-pink-200">
          <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
            👩‍🌾 {language === 'marathi' ? 'महिला बचत गटाबद्दल' : 'About Women Self-Help Group'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-bold text-pink-700 text-lg mb-3">📈 {language === 'marathi' ? 'आमची कथा' : 'Our Story'}</h3>
              <p className="text-gray-700">
                {language === 'marathi' 
                  ? 'इनाम धामणी ग्रामपंचायतीतील 15 महिला बचत गट एकत्रितपणे ही उत्पादने तयार करतात. प्रत्येक उत्पादन हे स्थानिक कच्च्या मालापासून, पारंपारिक पद्धतीने तयार केले जाते. आमचे उद्दिष्ट महिलांना स्वयंरोजगाराची संधी निर्माण करणे आणि ग्रामीण अर्थव्यवस्थेला चालना देणे आहे.'
                  : '15 women self-help groups in Inam Dhamani Gram Panchayat collectively prepare these products. Every product is made from local raw materials using traditional methods. Our goal is to create self-employment opportunities for women and boost the rural economy.'}
              </p>
            </div>
            <div>
              <h3 className="font-bold text-purple-700 text-lg mb-3">🎯 {language === 'marathi' ? 'आमची ध्येये' : 'Our Goals'}</h3>
              <ul className="list-disc pl-5 space-y-2 text-gray-700">
                {language === 'marathi' ? (
                  <>
                    <li>महिला सक्षमीकरण आणि आर्थिक स्वातंत्र्य</li>
                    <li>पारंपारिक हस्तकलेचे संवर्धन</li>
                    <li>पर्यावरणास अनुकूल उत्पादने तयार करणे</li>
                    <li>स्थानिक रोजगार निर्मिती</li>
                    <li>ग्रामीण विकासासाठी योगदान</li>
                  </>
                ) : (
                  <>
                    <li>Women empowerment and financial independence</li>
                    <li>Preservation of traditional handicrafts</li>
                    <li>Creating eco-friendly products</li>
                    <li>Local employment generation</li>
                    <li>Contribution to rural development</li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="mt-8 text-center">
          <div className="inline-flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-12 bg-white p-6 rounded-xl shadow-lg border border-pink-200">
            <div className="text-center">
              <p className="text-sm font-semibold text-gray-700">📞 {language === 'marathi' ? 'ऑर्डरसाठी संपर्क:' : 'Contact for Orders:'}</p>
              <p className="text-gray-800 font-bold text-lg">९८७६५४३२१०</p>
            </div>
            <div className="h-12 w-px bg-pink-200 hidden md:block"></div>
            <div className="text-center">
              <p className="text-sm font-semibold text-gray-700">🏢 {language === 'marathi' ? 'गट संयोजक:' : 'Group Coordinator:'}</p>
              <p className="text-gray-800 font-bold text-lg">{language === 'marathi' ? 'श्रीमती. सुनंदा पाटील' : 'Mrs. Sunanda Patil'}</p>
            </div>
            <div className="h-12 w-px bg-pink-200 hidden md:block"></div>
            <div className="text-center">
              <p className="text-sm font-semibold text-gray-700">✉️ {language === 'marathi' ? 'ईमेल:' : 'Email:'}</p>
              <p className="text-gray-800 font-bold text-lg">womensgroup@inamdhamani-grampanchayat.in</p>
            </div>
          </div>
        </div>
      </div>

      {/* Product Modal */}
      {isModalOpen && selectedProduct && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              {/* Close Button */}
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center text-gray-700 hover:bg-white shadow-lg"
              >
                ✕
              </button>

              <div className="grid grid-cols-1 lg:grid-cols-2">
                {/* Left: Product Images */}
                <div className="p-6">
                  <div className="rounded-xl overflow-hidden mb-4">
                    <img
                      src={selectedProduct.image}
                      alt={selectedProduct.name[language] || selectedProduct.name.marathi}
                      className="w-full h-96 object-cover"
                    />
                  </div>
                  <div className="grid grid-cols-4 gap-2">
                    {[1, 2, 3, 4].map(i => (
                      <div key={i} className="rounded-lg overflow-hidden border border-gray-200 cursor-pointer hover:border-pink-500">
                        <img
                          src={selectedProduct.image}
                          alt={`${selectedProduct.name[language] || selectedProduct.name.marathi} ${i}`}
                          className="w-full h-20 object-cover"
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right: Product Details */}
                <div className="p-8">
                  {/* Product Header */}
                  <div className="mb-6">
                    <div className="flex justify-between items-start">
                      <div>
                        <h2 className="text-3xl font-bold text-gray-800">{selectedProduct.name[language] || selectedProduct.name.marathi}</h2>
                        <p className="text-gray-600 text-lg">{getCategoryName(selectedProduct.category)}</p>
                      </div>
                      {selectedProduct.discount && (
                        <span className="bg-gradient-to-r from-red-500 to-pink-500 text-white px-4 py-2 rounded-full font-bold">
                          {selectedProduct.discount} OFF
                        </span>
                      )}
                    </div>

                    {/* Rating */}
                    <div className="flex items-center mt-4">
                      <div className="flex text-yellow-500 mr-2">
                        {'★'.repeat(Math.floor(selectedProduct.rating))}
                        {'☆'.repeat(5 - Math.floor(selectedProduct.rating))}
                      </div>
                      <span className="font-bold text-gray-700">{selectedProduct.rating}</span>
                      <span className="text-gray-500 ml-2">({selectedProduct.reviews} {language === 'marathi' ? 'रिव्ह्यू' : 'Reviews'})</span>
                      <span className={`ml-4 px-2 py-1 rounded text-sm font-bold ${
                        selectedProduct.inStock 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-red-100 text-red-800'
                      }`}>
                        {selectedProduct.inStock 
                          ? (language === 'marathi' ? '📦 स्टॉकमध्ये' : '📦 In Stock') 
                          : (language === 'marathi' ? '❌ संपले' : '❌ Out of Stock')}
                      </span>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="mb-6 p-4 bg-gradient-to-r from-pink-50 to-rose-50 rounded-xl">
                    <div className="flex items-center">
                      <span className="text-4xl font-bold text-rose-600">{selectedProduct.price}</span>
                      {selectedProduct.originalPrice && (
                        <span className="text-2xl text-gray-400 line-through ml-4">
                          {selectedProduct.originalPrice}
                        </span>
                      )}
                      <span className="ml-auto text-lg font-semibold">
                        {language === 'marathi' ? 'स्टॉक:' : 'Stock:'} {selectedProduct.stockCount} {language === 'marathi' ? 'युनिट्स' : 'Units'}
                      </span>
                    </div>
                  </div>

                  {/* Description */}
                  <div className="mb-6">
                    <h3 className="font-bold text-gray-800 text-xl mb-3">📝 {language === 'marathi' ? 'वर्णन' : 'Description'}</h3>
                    <p className="text-gray-700 leading-relaxed">{selectedProduct.detailedDescription[language] || selectedProduct.detailedDescription.marathi}</p>
                  </div>

                  {/* Product Details */}
                  <div className="mb-6 grid grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-sm text-gray-500">{language === 'marathi' ? 'साहित्य' : 'Material'}</div>
                      <div className="font-semibold">{selectedProduct.material[language] || selectedProduct.material.marathi}</div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-sm text-gray-500">{language === 'marathi' ? 'आकार' : 'Size'}</div>
                      <div className="font-semibold">{selectedProduct.size[language] || selectedProduct.size.marathi}</div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-sm text-gray-500">{language === 'marathi' ? 'वजन' : 'Weight'}</div>
                      <div className="font-semibold">{selectedProduct.weight[language] || selectedProduct.weight.marathi}</div>
                    </div>
                    <div className="bg-gray-50 p-3 rounded-lg">
                      <div className="text-sm text-gray-500">{language === 'marathi' ? 'काळजी' : 'Care'}</div>
                      <div className="font-semibold">{selectedProduct.careInstructions[language] || selectedProduct.careInstructions.marathi}</div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex gap-4">
                    <button className="flex-1 bg-gradient-to-r from-pink-500 to-rose-500 text-white py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-shadow">
                      🛒 {language === 'marathi' ? 'आत्ता खरेदी करा' : 'Buy Now'}
                    </button>
                    <button className="flex-1 bg-white border-2 border-pink-500 text-pink-600 py-4 rounded-xl font-bold text-lg hover:bg-pink-50 transition-colors">
                      💖 {language === 'marathi' ? 'विश लिस्टमध्ये ठेवा' : 'Add to Wishlist'}
                    </button>
                  </div>

                  {/* Additional Info */}
                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <div className="flex items-center text-green-600">
                      <span className="text-xl mr-2">✅</span>
                      <span className="font-semibold">{language === 'marathi' ? 'पैसे परत करण्याची हमी' : 'Money Back Guarantee'}</span>
                    </div>
                    <div className="flex items-center text-blue-600 mt-2">
                      <span className="text-xl mr-2">🚚</span>
                      <span className="font-semibold">{language === 'marathi' ? 'इनाम धामणीमध्ये फ्री डिलिव्हरी' : 'Free Delivery in Inam Dhamani'}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WomenGroup;